import {
  WIPE_PW_RESET,
  PW_RESET_REQUEST,
  PW_RESET_SUCCESS,
  PW_RESET_FAILURE,
} from "../actions/constants";

export const initialState = {};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case WIPE_PW_RESET:
    case PW_RESET_REQUEST:
      return initialState;
    case PW_RESET_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: undefined,
      };
    case PW_RESET_FAILURE:
      console.error("pw_reset_failure", action);
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
